export const libelles = {
  donneesMois: "Données pour le mois",
  marche: "Marché",
  soumettre: "Soumettre",
  reinitialiser: "Réinitialiser",
  messageHorsPeriodeSoumission: "Ce formulaire est saisi ou modifié ou supprimé en dehors de la période autorisée. Il est donc soumis à validation de l'administrateur",
  confirmationDispenseUtilisateur: "Merci de confirmer que vous n'avez aucune donnée à saisir pour cette période",
  messageCreateFormulaireWithDispense: "Vous avez auparavant déclaré que vous n'aviez aucune donnée pour cette période. Cependant, nous vous confirmons que votre formulaire a bien été pris en compte.",
  buttonRienDeclarer: "Rien à déclarer",
  libelleRienDeclarer: "Si vous n'avez aucune donnée à saisir pour la période sélectionnée, merci de cliquer ici :",
  selectionnerMarche: "Sélectionner un marché",
  champsObligatoires: "champs obligatoires",
  confirmerSuppression: "Confirmer la suppression",
  confirmerModification: "Confirmer la modification",
  ligne: "Ligne",
  selectionnerLigne: "Sélectionner une ligne",
  exporter: "Exporter",
  dateDebut: "Date de début",
  dateFin: "Date de fin",
  dateCreation: "Date de création",
  statut: "Statut",
  champObligatoire: "Ce champs est obligatoire",
  demandeConfirmation: "Demande de confirmation",
  infoBulleNumMarche: "Numéro de marché SGP",
  commentaire: "commentaire",
  importer: "Importer",
  trimestreSaisie: "Trimestre de la saisie",
  allMarches: "Tous les marchés",
  allLines: "Toutes les lignes",
  commentaireStatut: "Raison du rejet",
  messageLocalStorage: "Ce formulaire est pré-rempli avec les données de votre dernière saisie.",
};
export const accidentologie = {
  infoBulleEncadrement: "Effectifs encadrement total (groupement + sous-traitants) sur les chantiers",
  infoBulle12moisGlissant: "Somme sur les 12 derniers mois",
  infoBullePersonnel: "Personnel du groupement hors encadrement",
  libellePersonnelHorsEncadrement: "Personnel (hors encadrement)",
  libelle12MoisGlissant: "12 mois glissants",
  libelleInterimaires: "Intérimaires",
  libelleSousTraitants: "Sous-Traitants",
  libelleGlobalChantierHorsEncadrement: "Global chantier (hors encadrement)",
  libelleEncadrement: "Encadrement",
  libelleGlobalChantier: "Global chantier",
  libelleMois: "Mois",
  libelleEntete: "Les données d'accidentologie déclarées concernent uniquement celles relatives aux travaux effectués sur les chantiers sous maîtrise d'ouvrage SGP.",
  confirmationSuppression: "Confirmez-vous la suppression de ces données d'accidentologie ?",
  confirmationModification: "Confirmez-vous la modification de ces données d'accidentologie ?",
  erreur12mMessage: "Les valeurs sur 12 mois sont inférieurs à celles des mois sélectionnés",
  erreurNbHeuresMessage: "Erreur sur les nombres d'heures travaillées et les champs indiqués",
};
export const empreinteEco = {
  infoBulleDonneesMois: "Indiquer le mois des engagements (n-1 du mois de saisie)",
  infoBulleEntrepriseId: "Numéro unique d'identification de l'établissement (14 chiffres)",
  libelleNouvelleEntreprise: "Soumettre une nouvelle entreprise",
  messageEntrepriseId: "Veuillez entrer une entreprise faisant partie du référentiel",
  libelleEss: "ESS (au sens de la Loi n°2014-856 du 31 juillet 2014 relative à l'Economie Sociale et Solidaire)",
  infoBulleEss: "1. Structures d'insertion par l'activité économique mentionnées à l'article L. 5132-4 du code du travail et à des structures équivalentes (EI, AI, ACI, ETTI, régie de quartier,…). 2. Structure d'insertion professionnelle de personnels handicapés EA, ESAT ou structures équivalentes employant principalement des personnes handicapées. 3. Entreprise de l'économie sociale et solidaire ESS (coopérative, association loi 1901, …).",
  libelleQualificationFournisseur: "L'exécution de l'obligation d'accès des PME est calculée à la fin du marché : une déclaration saisie sur S-Print ne vaut pas acceptation par la SGP",
  libellePme: "PME (au titre de la recommandation 2003/361/CE)",
  infoBullePme: "Une PME doit cumuler 3 critères : <250 salariés, </=50M€ de CA ou </=43M€ de bilan total, <25% de participation (capital ou droits de vote) par une autre entreprise partenaire",
  libelleFrancilienne: "Siège en IdF",
  infoBulleFrancilienne: "Siège localisé en Ile de France ?",
  libelleAgenceIdf: "Agence en IdF",
  infoBulleAgenceIdf: "Agence localisé en Ile de France ?",
  libelleChiffreAffaire: "Chiffre d'affaires (en euros)",
  infoBulleChiffreAffaire: "Chiffre d'affaire déclaré par l'entreprise (année n-2 de la notification du marché)",
  libelleEffectif: "Effectif global",
  infoBulleEffectif: "Volume d'effectif déclaré par l'entreprise (année n-2 de la notification du marché)",
  libelleAnneeCA: "Année de référence du chiffre d'affaire",
  infoBulleAnneeCA: "Année de référence du CA déclaré (année n-2 de la notification du marché)",
  libelleAnneeEffectif: "Année de référence de l'effectif global",
  infoBulleAnneeEffectif: "Année de référence de l'effectif global déclaré (année n-2 de la notification du marché)",
  libelleNature: "Nature",
  infoBulleNature: "Choisir dans la liste la situation contractuelle de l'entreprise sur ce marché",
  libelleSousTraitantId: "SIRET du commanditaire",
  libelleRangSousTraitant: "Rang de la sous-traitance",
  libelleObjetPrestation: "Objet de la prestation",
  libelleMontantM2: '',
  infoBulleObjetPrestation: "Type de prestation réalisée",
  codeNaf: "Code NAF",
  libelleCategoriePrestation: "Secteur d'activité",
  infoBulleCategoriePrestation: "Choisir dans la liste, la Catégorie de la prestation. Si la catégorie ne se trouve pas dans la liste, indiquer Autre et saisir manuellement le secteur d'activité",
  libelleCategoriePrestationAutre: "Secteur d'activité (autre)",
  libelleDatePremiereCommande: "Date de première commande",
  infoBulleDatePremiereCommande: "Date du premier engagement",
  libelleDC4: "DC4",
  infoBulleDC4: "Si sous-traitant, présence d'un DC4 ?",
  libelleMontantMarche: "Montant versé à date (en euros)",
  infoBulleMontantMarche: "Indiquer le montant cumulé versé à date",
  libelleMontantPmeEntreprise: "Montant identifié PME par entreprise à date (en euros)",
  infoBulleMontantPmeEntreprise: "Si PME, indiquer le montant de l'engagement. Sinon, indiquer 0",
  libelleNumeroIdentification: "Numéro d'identification",
  infoBulleNumeroIdentification: "Vous pouvez renseigner ici un numéro d'identification de cette empreinte",
  libelleEntrepriseSiret: "Entreprise SIRET",
  libelleEntrepriseNom: "Entreprise nom",
  bilanTotal: "Bilan total",
  infoBulleBilanTotal: "Année de référence du bilan total déclaré (année n-2 de la notification du marché)",
  autonome: "Entreprise autonome",
  infoBulleBilanAutonome: "Si moins de 25% de participation (capital ou droits de vote) par une autre entreprise partenaire",
  libellePMEAutonomieAvant2021:" Pour les empreintes économiques dont la date de commande est antérieur au 01/01/2021 : l'exécution de l'obligation d'accès des PME est calculée à la fin du marché : une déclaration saisie sur S-Print ne vaut pas acceptation par la SGP.",
  libellePMEAutonomieApres2021:" Pour les empreintes économiques dont la date de commande est postérieur au 01/01/2021 : les données EFFECTIF, CA, Bilan total provenant d’INFOLEGALE sont validés par la SGP. Les déclarations de l'autonomie et du statut PME sont modifiables sur S-Print et ne valent pas acceptation par la SGP.",
  libellePMEAutonomieNote:" A noter : Le statut PME d'une entreprise à prendre en compte est son statut lors de la première empreinte économique effectuée sur votre marché avec cette entreprise.",
  PMEautonomeIndicatives:"xxx",
  bilanInfolegale:' Le Bilan provient de Infolegale',
  chiffreAffaireInfolegale:' Le Chiffre d\'affaire provient de Infolegale',
  effectifInfolegale:' L\'effectif provient de Infolegale',
  libellePieceJustificative: "Justificatif",
  infoBullePieceJustificative: "Facture qui doit faire apparaitre le montant versé depuis la date de la première commande."
};

export const effectifs = {
  libellePieceJustificative: "Justificatif",
  infobulleNbMaxEffectifCadre: "Effectif encadrement et ETAM maximal prévus lors du pic d'activité sur les chantiers",
  infobulleNbMaxEffectifOuvrier: "Effectif ouvrier maximal prévus lors du pic d'activité sur les chantiers",
  infoBulleNbTravDetach: "Nombre de travailleurs détachés sur le projet pour le mois en cours. Un travailleur détaché est un salarié envoyé par son employeur dans un autre Etat membre en vue d'y fournir un service à titre temporaire."
};

export const home = {
  title: "Bienvenue sur S-Print, portail de la Société du Grand Paris dédié au reporting de la donnée d'empreinte économique, des effectifs, d'accidentologie et de Gestion Prévisionnelle des Emplois et Compétences (GPEC)",
  subTitle: "Sur cette page, vous pouvez suivre l'état d'avancement de votre reporting."
};

export const gpecPrevisionnel = {
  libelleEntreprisesConcernees: "Entreprise(s) concernée(s) par le besoin identifié",
  infoBulleEntreprisesConcernees: "Si le besoin identifié concerne pour tout ou partie une autre entreprise que le mandataire, merci de le préciser, en veillant à préciser le cas échéant, la répartition des contrats et d'une éventuelle formation"
};
export const gpecRealise = {
  libelleEntreprisesConcernees: "Entreprise(s) concernée(s) par le recrutement réalisé",
  infoBulleEntreprisesConcernees: "Si le recrutement effectué concerne pour tout ou partie une autre entreprise que le mandataire, merci de le préciser, en veillant à préciser le cas échéant, la répartition des contrats et d'une éventuelle formation"
};
